var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page wutai-perspective po pointer",style:(_vm.getStyles)},[_c('div',{staticClass:"wutai-box3d preserve3d po"},[_c('img',{staticClass:"wutai-turn po",attrs:{"src":_vm.mode['im']}})])])}
var staticRenderFns = []

export { render, staticRenderFns }